import __request__ from "routing/request";
export function run(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.aiagent/agent-workflow/run", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function usedModels(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.aiagent/agent-workflow/runs/models", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function runsPaginated(page = 1, per_page = 20, sort = "ran_at", order = "desc", query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiagent/agent-workflow/runs/paginated", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function runsSlices(slice_column = "type", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiagent/agent-workflow/runs/slices", null, { "slice_column": slice_column }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function tokenUsage(requests, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.aiagent/agent-workflow/runs/token-usage", requests, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function tokenUsageBreakdown(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.aiagent/agent-workflow/runs/token-usage/breakdown", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRun(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.aiagent/agent-workflow/runs/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
